module.exports = "/static/assets/14ff0e9e964d43617c7298df4b888d10.png";